import AnimationClip from '../AnimationClip';
import Renderable from '../../../Component/Renderable';
import { AwaitIterators } from '../AnimationHelper';
import StarChest from '../../../Prefabs/StarChest/StarChest';
import ElementComponent from '../../../Component/UI/Element';
import { Easing } from '@tweenjs/tween.js';
import { PlaySound } from '../../Audio/AudioHelper';
import Game from '../../../Game';
import { AudioTrackType } from '../../Audio/AudioClip';
import { RenderSystemEvent } from 'System/Render/RenderSystem';
import WorldSystem from 'System/World/WorldSystem';

export interface StarChestFallParams {}

export class StarChestFall extends AnimationClip<StarChestFallParams> {
    public *execute(
        gameObject: StarChest,
        meta?: StarChestFallParams
    ): IterableIterator<number> {
        PlaySound('new-chest-spawn');
        // just `gameObject.parent` breaks transforms
        const oldParent = gameObject.parent.parent;
        const objectToBringToFront = gameObject.parent;
        const worldSystem = Game.scene.getActiveScene().getSystem(WorldSystem);


        worldSystem.animator.addChild(objectToBringToFront);
        worldSystem.animator.scene.emit(
            RenderSystemEvent.BRING_TO_FRONT,
            worldSystem.animator
        );

        const starChestElement = gameObject.getComponent(ElementComponent);
        const starChestRenderable = gameObject.getComponent(Renderable);

        starChestRenderable.alpha = 0;
        starChestRenderable.visible = true;

        const alphaTween = this.getTween(starChestRenderable)
            .to({ alpha: 1 }, 250)
            .easing(Easing.Quadratic.Out);

        // Fall motion
        const originalOffsets = starChestElement.offsets;
        starChestElement.offsets = [0, 500, 0, 500];
        const offsetTween = this.getTween(starChestElement.offsets)
            .to(originalOffsets, 1100)
            .easing(Easing.Bounce.Out)
            .onUpdate(t => (starChestElement.offsets = t));

        yield* AwaitIterators([
            this.startTween(alphaTween),
            this.startTween(offsetTween),
        ]);

        oldParent.addChild(objectToBringToFront);
    }
}
